import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Track the error using the same event tracking as normal JS errors
    if (typeof trackEvent === 'function') {
      trackEvent('js_error_happened', {
        context: 'react_error_boundary',
        component: this.props.componentName || 'unknown',
        error_message: error.toString(),
        error_stack: error.stack,
        component_stack: errorInfo.componentStack,
        // Include any additional context passed via props
        ...this.props.errorContext
      });
    }

    // Log to console for development
    console.error('React Error Boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback || (
        <div style={{
          padding: '20px',
          margin: '20px 0',
          border: '1px solid #ffcccc',
          borderRadius: '4px',
          backgroundColor: '#fff5f5',
          color: '#cc0000'
        }}>
          <h3>Something went wrong</h3>
          <p>We've been notified about this issue. Please try refreshing the page.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
